// src/pages/LoginPage.tsx
import React, { useEffect, useState } from "react";
import { App as AntdApp, Button, Form, Input, Typography, Card } from "antd";
import { useAuth } from "../auth/AuthContext.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import faviconUrl from "../logo.png"; // убедись, что файл реально лежит по пути

const { Title } = Typography;

type LoginFormValues = {
  email: string;
  password: string;
};

export default function LoginPage(): JSX.Element {
  const { isAuthenticated, login } = useAuth();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const nav = useNavigate();
  const loc = useLocation();

  // ВАЖНО: берём message из контекста Antd
  const { message } = AntdApp.useApp();

  // returnUrl из query
  const returnUrl: string | null = new URLSearchParams(loc.search).get("returnUrl");

  useEffect(() => {
    document.title = "Вход — Jetrub";

    // favicon
    const setFav = (rel: string, href: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = "image/png";
      link.sizes = "32x32";
      link.href = href;
    };
    setFav("icon", faviconUrl);
    setFav("shortcut icon", faviconUrl);

    if (isAuthenticated) {
      nav("/", { replace: true });
    }
  }, [isAuthenticated, nav]);

  const onFinish = async (values: LoginFormValues) => {
    setSubmitting(true);
    try {
      await login({ email: values.email, password: values.password });
      message.success("Добро пожаловать!");
      nav(returnUrl && returnUrl !== "" ? returnUrl : "/worker/orders", { replace: true });
    } catch (e: any) {
      const msg = e?.response
        ? `[${e.response.status}] ${e.response.data ?? "Ошибка входа"}`
        : (e?.message || "Ошибка входа");
      message.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <Card style={{ width: "100%", maxWidth: 420, borderRadius: 16 }} bodyStyle={{ padding: 24 }}>
        <Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
          Вход
        </Title>

        <Form<LoginFormValues> layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Поле «Email» обязательно" },
              { type: "email" as const, message: "Введите корректный адрес" },
            ]}
          >
            <Input placeholder="Email" size="large" />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: "Введите пароль" }]}
          >
            <Input.Password placeholder="Пароль" size="large" />
          </Form.Item>

          <Form.Item style={{ marginTop: 8 }}>
            <Button type="primary" htmlType="submit" block loading={submitting} size="large">
              Войти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
